/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'doc': {
    width: 21,
    height: 26,
    viewBox: '0 0 21 26',
    data: '<path pid="0" d="M0 0h15.763L21 4.986V26H0V0z" _fill="#C4C4C4"/>'
  }
})
